import type { CSSProperties, ReactNode } from 'react';
import { colors } from './theme';

// Shared visual language for every /create/* flow — used by CreateFlowPage
// and CreateAiAgentPage so no single page's form can visually drift from
// the rest (a real bug once: the AI Agent page shipped its own bespoke
// terminal/ASCII style and looked bolted-on next to Worker/Backend/Frontend).

export const inputStyle: CSSProperties = {
  width: '100%',
  padding: '9px 12px',
  borderRadius: 8,
  border: `1px solid ${colors.border}`,
  fontSize: 14,
  color: colors.text,
  background: colors.surface,
};

export const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: 13,
  fontWeight: 600,
  color: colors.text,
  marginBottom: 6,
};

export function Field({ children }: { children: ReactNode }) {
  return <div style={{ marginBottom: 20 }}>{children}</div>;
}

export function ProgressStepper({ stages, currentStage }: { stages: readonly string[]; currentStage: number }) {
  return (
    <div>
      {stages.map((stage, i) => {
        const done = i < currentStage;
        const active = i === currentStage;
        return (
          <div key={stage} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0' }}>
            <div
              aria-hidden="true"
              style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
                background: done ? colors.success : active ? colors.primary : colors.borderLight,
                color: done || active ? '#fff' : colors.textMuted,
              }}
            >
              {done ? '✓' : i + 1}
            </div>
            <span
              style={{
                fontSize: 14,
                color: active ? colors.text : colors.textMuted,
                fontWeight: active ? 600 : 400,
              }}
            >
              {stage}
              {active ? '…' : ''}
            </span>
          </div>
        );
      })}
    </div>
  );
}
